import { useContext, useEffect, useMemo, useRef, useState } from 'react';
import axiosConn from '../../axiosConn';
import { AuthContext } from '../../context/AuthContext';
import RewardCard from '../rewardCard/RewardCard';

const REWARD_DISPLAY_MS = 3500;
const REWARD_FADE_MS = 500;

export default function DailyVisitRail() {
  const { player } = useContext(AuthContext);
  const [rewardData, setRewardData] = useState(null);
  const [status, setStatus] = useState('idle');
  const [isFading, setIsFading] = useState(false);
  const [isHidden, setIsHidden] = useState(false);
  const fadeTimerRef = useRef(null);
  const hideTimerRef = useRef(null);

  const playerId = player?.data?.player?.playerId;
  const token = player?.token;
  const today = useMemo(() => new Date().toISOString().split('T')[0], []);
  const lastPingKey = useMemo(
    () => `lastDailyVisit_${playerId || 'unknown'}`,
    [playerId],
  );

  useEffect(() => {
    if (!playerId || !token) return;
    const lastPing = localStorage.getItem(lastPingKey);
    if (lastPing === today) {
      setStatus('checked');
      return;
    }

    setStatus('pending');
    axiosConn
      .get('players/daily-visit', {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        localStorage.setItem(lastPingKey, today);
        setRewardData(res.data.data || null);
        setStatus('earned');
        setIsHidden(false);
        setIsFading(false);
      })
      .catch((err) => {
        console.error('Daily visit failed:', err);
        setStatus('idle');
      });
  }, [playerId, token, today, lastPingKey]);

  useEffect(() => {
    if (status !== 'earned' || !rewardData) return undefined;
    fadeTimerRef.current = setTimeout(() => {
      setIsFading(true);
    }, REWARD_DISPLAY_MS);
    hideTimerRef.current = setTimeout(() => {
      setIsHidden(true);
    }, REWARD_DISPLAY_MS + REWARD_FADE_MS);
    return () => {
      clearTimeout(fadeTimerRef.current);
      clearTimeout(hideTimerRef.current);
    };
  }, [status, rewardData]);

  if (!playerId || !token) return null;
  if (status !== 'earned' || !rewardData) return null;
  if (isHidden) return null;

  return (
    <div
      className={`dailyVisitRewardOverlay${
        isFading ? ' dailyVisitRewardOverlay--fade' : ''
      }`}
    >
      <RewardCard
        title="Daily Visit Recorded!"
        rewards={{
          xp: rewardData?.xpEarned ?? 0,
          jgk: rewardData?.jgkEarned ?? 0,
          streak: rewardData?.loginStreak ?? 0,
        }}
        showConfetti={true}
        category="dailyVisit"
      />
    </div>
  );
}
